import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess6020BerechnungStatus: 'idle',
    startProcess6020BerechnungError: undefined as any,
    loadUserParamsProcess6020BerechnungStatus: 'idle',
    loadUserParamsProcess6020BerechnungError: undefined as any,

    process6020BerechnungList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess6020Berechnung = createAsyncThunk('process6020BerechnungSlice/startProcess6020Berechnung', async ({ process6020Berechnung }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess6020Berechnung/`,
        prepareData(process6020Berechnung),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess6020BerechnungStatus } = getState().process6020BerechnungSlice
        return startProcess6020BerechnungStatus !== 'pending'
    }
})

export const loadUserParamsProcess6020Berechnung = createAsyncThunk('process6020BerechnungSlice/loadUserParamsProcess6020Berechnung', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess6020Berechnung/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess6020BerechnungStatus } = getState().process6020BerechnungSlice
        return loadUserParamsProcess6020BerechnungStatus !== 'pending'
    }
})

const Process6020BerechnungSlice = createSlice({
    name: 'process6020BerechnungSlice',
    initialState,
    reducers: {
        resetstartProcess6020Berechnung: (state) => {
            state.job = undefined
            state.startProcess6020BerechnungError = undefined
        },
        resetstartProcess6020BerechnungError: (state) => {
            state.startProcess6020BerechnungError = undefined
        },
        resetloadUserParamsProcess6020Berechnung: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess6020BerechnungError = undefined
        },
        resetloadUserParamsProcess6020BerechnungError: (state) => {
            state.loadUserParamsProcess6020BerechnungError = undefined
        },
        removeFromProcess6020BerechnungListById: (state, action) => {
            state.process6020BerechnungList = state.process6020BerechnungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess6020BerechnungListByIds: (state, action) => {
            state.process6020BerechnungList = state.process6020BerechnungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process6020BerechnungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess6020BerechnungStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process6020BerechnungList = []
            state.startProcess6020BerechnungStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess6020Berechnung.pending, (state) => {
            state.startProcess6020BerechnungStatus = 'pending'
            state.startProcess6020BerechnungError = undefined
        })
        builder.addCase(startProcess6020Berechnung.fulfilled, (state, action) => {
            state.startProcess6020BerechnungStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess6020Berechnung.rejected, (state, action) => {
            state.startProcess6020BerechnungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess6020BerechnungError = action.error.message
            } else {
                state.startProcess6020BerechnungError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess6020Berechnung.pending, (state) => {
            state.loadUserParamsProcess6020BerechnungStatus = 'pending'
            state.loadUserParamsProcess6020BerechnungError = undefined
        })
        builder.addCase(loadUserParamsProcess6020Berechnung.fulfilled, (state, action) => {
            state.loadUserParamsProcess6020BerechnungStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess6020Berechnung.rejected, (state, action) => {
            state.loadUserParamsProcess6020BerechnungStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess6020BerechnungError = action.error.message
            } else {
                state.loadUserParamsProcess6020BerechnungError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess6020Berechnung,
    resetstartProcess6020BerechnungError,
    resetloadUserParamsProcess6020Berechnung,
    resetloadUserParamsProcess6020BerechnungError,
    removeFromProcess6020BerechnungListById,
    removeFromProcess6020BerechnungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process6020BerechnungSlice.actions
export default Process6020BerechnungSlice.reducer
